export default {"src":"/_next/static/media/ic_player_icon_instamatch.ec1982fb.svg","height":11,"width":8,"blurWidth":0,"blurHeight":0};